import { Routes } from "@angular/router";
import { PendingSectionsComponent } from "../upgrade/admin.directive";
import { TwoColumnsRightComponent } from "../upgrade/main.template.directive";
import { setupGuard } from '@fry/upgrade/setup.guard';
import { forceOnlineGuard } from '@fry-it/risr-core';

export const adminRoutes: Routes = [
    {
        path: 'admin',
        component: TwoColumnsRightComponent,
        canActivate: [setupGuard],
        children: [
            {
                path: 'pending-sections',
                component: PendingSectionsComponent,
                data: {
                    state: 'epf.admin.pending-sections'
                },
                canActivate: [setupGuard, forceOnlineGuard]
            }
        ]
    }
];